<template lang="pug">
  app-modal(
    titulo="Assinatura/Token",
    @closeModal="$emit('closeModal')",
    :closeOutside="false"
  )
    template(slot="body")
      div
        el-row
          span.title Token
          el-col.margin-top(:lg="24", :md="24", :sm="24")
            el-row(v-if="usuario && usuario.nome").token
              el-col(:lg="22", :md="22", :sm="22")
                span {{usuario.nome}}

            el-row.container(v-else)
              el-col(:lg="24", :md="24", :sm="24").text-center
                span.border-span Não há token cadastrado.
        el-row
          el-col(:lg="24", :md="24", :sm="24")
          .labels-action(
            :class="!usuario.dataAtualizacaoToken && !usuario.dataValidadeToken ? 'margin-top' : ''",
            v-if="usuario && usuario.nome"
          )
            .flex-column
              span(v-if="usuario && usuario.dataAtualizacaoToken").font-12 Atualizado em {{usuario.dataAtualizacaoToken}}
              span(v-if="usuario && usuario.dataValidadeToken").font-12 Válido até {{usuario.dataValidadeToken}}
        el-row.margin-top-20
          span.title Assinatura simbólica
          .container-img
            .border-img(v-if="usuario && usuario.id && hasImagemAssinatura")
              img.image-assinatura(:src="`usuarios/publico/fa861ef9-9acb-4e88-a889-f603b043dc73/${usuario.id}`")
            span.border-span(v-else) Não há assinatura cadastrada.
          .flex-start(v-if="hasImagemAssinatura")
            span(v-if="usuario.dataAtualizacaoAssinatura").font-12 Atualizado em {{ usuario.dataAtualizacaoAssinatura }}
</template>

<script>
import AppModal from '@/components/AppModal'
import axios from '@/utils/api'
export default {
  components: {
    AppModal
  },

  data () {
    return {
      hasImagemAssinatura: null
    }
  },

  props: {
    usuario: {
      type: Object,
      required: true
    }
  },

  mounted () {
    this.getImagemAssinatura()
  },

  methods: {
    async getImagemAssinatura () {
      this.hasImagemAssinatura = await axios({
        method: 'GET',
        url: `usuarios/publico/fa861ef9-9acb-4e88-a889-f603b043dc73/${this.usuario.id}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: bold;
}
.text-center {
  text-align: center;
}
.token {
  height: 60px;
  padding: 15px;
  display: flex;
  align-content: center;
  align-items: center;
  align-self: center;
  margin-right: 0px;
  background-color: rgb(218, 218, 218);
  border-radius: 10px;
}
.labels-action {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.image-assinatura {
  width: 700px;
  height: auto;
}
.flex-column {
 display: flex;
 justify-content: flex-end;
 flex-direction: column;
 padding-left: 15px;
 padding-bottom: 0px;
 padding-top: 0px;
 span {
   margin-bottom: 5px;
 }
}
.font-12 {
  font-size: 12px;
}
.margin-top-20 {
  margin-top: 20px;
}
.container-img {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
}
.border-img {
  border-style: solid;
  width: 99.5%;
  color: #d3dce6;
  text-align: center;
}
.flex-start {
  display: flex;
  justify-content: flex-start;
  padding-left: 15px;
  span {
   margin-top: 5px;
 }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppModalAssinaturaToken.vue